import { useState } from "react";
import { cn } from "@/lib/utils";
import { FileText, Sparkles } from "lucide-react";
import { Switch, Textarea, Button } from "@heroui/react";
import DummyTemplateContentGenerator from "./dummy-template-content-generator";
export default function ContentGenerationPreview() {
  return <div className="relative z-[10] max-h-[418px] min-h-[418px] w-full" data-sentry-component="ContentGenerationPreview" data-sentry-source-file="content-generation-preview.tsx">
      <DummyTemplateContentGenerator data-sentry-element="DummyTemplateContentGenerator" data-sentry-source-file="content-generation-preview.tsx" />
      {/* Footer */}
      <div className="absolute bottom-0 left-0 right-0 min-h-16 w-full rounded-b-3xl bg-gradient-to-t from-black via-black to-transparent px-6 pb-6 pt-16">
        <div className="mb-2 flex items-center gap-2">
          <FileText className="h-5 w-5 text-white" data-sentry-element="FileText" data-sentry-source-file="content-generation-preview.tsx" />
          <h3 className="text-xl font-bold text-white">Content Generator</h3>
        </div>
        <p className="text-gray-300">
          Generate viral content for Twitter, Product Hunt, LinkedIn and more
          with AI-powered templates.
        </p>
      </div>
    </div>;
}